export default __webpack_public_path__ + "static/media/ieee2018project.61a2adab.jpg";